/* Copyright 2019 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Special version of GenericSettingsViewController for Angular upgrade
 * The prefix "zng1-" is required!
 */
namespace h5_client {
   module platform_ui {

      declare const h5: any;
      declare const angular: ng.IAngularStatic;

      export class GenericSettingsViewComponent implements ng.IComponentOptions {

         bindings: any = {};

         // Uses legacy template
         template:string='<div ng-class="ctrl.cssClass" data-test-id="generic-settings-view"> <vsc-settings-view-header [header-title]="ctrl.title" [actions]="ctrl.actions" [object-ids]="ctrl.watchForObjects" [accessor]="ctrl.settingsViewHeaderAccessor"> </vsc-settings-view-header> <clr-stack-view stack-view-overrides class="clr-component" vx-refreshable refresh="ctrl.refresh()" live-refresh-properties="ctrl.liveRefreshProperties" delay-refresh-on-object-updates-by="{{ctrl.delayRefreshOnObjectUpdatesBy}}" watch-objects="{{ctrl.watchForObjects}}"> <clr-stack-block ng-repeat="propertyItem in ctrl.propertyItems" [(clr-sb-expanded)]="propertyItem.expanded"> <clr-stack-label>{{propertyItem.label}}</clr-stack-label> <clr-stack-content> <div class="gsv-action-group"> <span ng-if="!propertyItem.expanded">{{propertyItem.value}}</span> <span ng-if="propertyItem.actions && propertyItem.actions.length" class="gsv-action-holder"> <button class="btn btn-link btn-sm" ng-repeat="action in ctrl.actionsToRender[propertyItem.index] track by action.actionId" ng-disabled="!action.isEnabled" ng-click="ctrl.invokeAction($event, action)">{{action.label}} </button> </span> </div> </clr-stack-content> <clr-stack-block ng-if="propertyItem.nestedProperties" ng-repeat="nestedPropertyItem in propertyItem.nestedProperties"> <clr-stack-label>{{nestedPropertyItem.label}}</clr-stack-label> <clr-stack-content>{{nestedPropertyItem.value}}</clr-stack-content> </clr-stack-block> </clr-stack-block> </clr-stack-view> </div>';

         controller = h5.ngMigrationResolveController(
               angular.module('com.vmware.platform.ui'), "GenericSettingsViewController");
         controllerAs = "ctrl";
      }

      angular.module('com.vmware.platform.ui')
         .component('genericSettingsView', new GenericSettingsViewComponent());
   }
}
